import styled from 'styled-components';

import { AnchorStyled } from '~src/modules/reports/shared/components/shared/RespondSections.sc';
import { orderedColorsSets } from '~src/styles/colors';

export const LabelWrapper = styled.div`
  display: flex;
`;

export const LabelContent = styled.span<{ $small?: boolean; $onlyText?: boolean }>`
  max-width: 230px;
  text-align: center;
  margin-top: ${({ $onlyText }) => ($onlyText ? '0' : '5px')};
  font-size: ${({ $small }) => ($small ? '12px' : 'inherit')};
  line-height: ${({ $small }) => ($small ? '16px' : 'inherit')};
  word-break: break-word;
`;

export const LabelRatingContainer = styled.div<{ $labelColor?: string }>`
  display: flex;
  flex-direction: column;
  color: ${({ $labelColor, theme }) => ($labelColor ? $labelColor : theme.white.a10)};
  justify-content: center;
  align-items: center;
  font-size: 15px;
  max-width: 25rem;
`;

export const NpsRatingContainer = styled.div<{ $empty: boolean; $rating: number; $blank?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 26px;
  width: 26px;
  color: ${({ theme }) => theme.white.a10};
  font-weight: 400;
  border-radius: 5px;
  font-size: 15px;
  border: ${({ $empty, theme, $blank }) => ($empty || $blank ? `1px solid ${theme.white.a10}` : 'none')};
  background-color: ${({ $empty, $rating, $blank }) =>
    !$empty && !$blank ? orderedColorsSets[11][$rating] : 'none'};
`;

export const LabelDisplay = styled.div<{ $empty: boolean; $colorCount: number; $selectedColorIndex: number }>`
  width: 20px;
  height: 11px;
  border-radius: 3px;
  font-size: 15px;
  border: ${({ $empty, theme }) => ($empty ? `1px solid ${theme.white.a10}` : 'none')};
  background-color: ${({ $empty, $colorCount, $selectedColorIndex }) =>
    !$empty ? orderedColorsSets[$colorCount][$selectedColorIndex] : 'none'};
`;

export const McqAnswerContainer = styled.ul<{ $showList?: boolean }>`
  max-width: 15rem;
  width: ${({ $showList }) => $showList ? '15rem' : 'auto'};
  text-align: ${({ $showList }) => $showList ? 'left' : 'center'};
  list-style: ${({ $showList }) => $showList ? 'disc' : 'none'};
`;

export const McqAnchorStyled = styled(AnchorStyled)`
  display: flex;
  align-items: flex-end;
  width: 100%;
  justify-content: flex-end;
  text-decoration: underline;
`;
